



// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// const services = [
//   {
//     id: 1,
//     title: "Quick Rentals",
//     desc: "Ideal for short trips and urgent requirements. Whether it’s airport transfers, corporate meetings, or daily staff commutes, our quick rental solutions ensure timely, comfortable, and hassle-free travel.",
//     icon: "images/icon-service-1.svg",
//     delay: "0s",
//   },
//   {
//     id: 2,
//     title: "Periodic Rentals",
//     desc: "Flexible rental options tailored to your needs. Choose from weekly, monthly, or long-term plans that provide cost-effective and reliable travel solutions for both personal and business purposes.",
//     icon: "images/icon-service-2.svg",
//     delay: "0.2s",
//   },
//   {
//     id: 3,
//     title: "Corporate Travel Solutions",
//     desc: "Designed for executives and employees, we provide seamless corporate mobility solutions. From scheduled office commutes to VIP transfers, we guarantee professionalism, punctuality, and comfort.",
//     icon: "images/icon-service-3.svg",
//     delay: "0.4s",
//   },
//   {
//     id: 4,
//     title: "Events & Exhibitions",
//     desc: "From weddings and family functions to seminars, conferences, and exhibitions—we offer reliable and well-coordinated transportation services that make every event smooth and stress-free.",
//     icon: "images/icon-service-4.svg",
//     delay: "0.6s",
//   },
//   {
//     id: 5,
//     title: "Customized Travel Packages",
//     desc: "Explore personalized travel experiences crafted for your needs. Be it family getaways, weekend trips, pilgrimages, or leisure tours, we design packages to give you a memorable journey.",
//     icon: "images/icon-service-5.svg",
//     delay: "0.8s",
//   },
//   {
//     id: 6,
//     title: "Luxury & VIP Transfers",
//     desc: "Travel in unmatched style and comfort with our premium chauffeur-driven luxury cars. Perfect for dignitaries, celebrities, and high-profile events where class, privacy, and exclusivity matter.",
//     icon: "images/icon-service-6.svg",
//     delay: "1s",
//   },
// ];

// const PageServices = () => {
//   return (


// <>



//     <div className="page-headder bg-section parallaxie">
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-12">
//             <div className="page-header-box">
//               <h1 className="text-anime-style-3" data-cursor="-opaque">
//                  Services
//               </h1>
             
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>



//     <div className="page-services py-5">
//       <div className="container">
//         {/* Services Section */}
//         <div className="row">
//           {services.map((service) => (
//             <div key={service.id} className="col-lg-4 col-md-6 mb-4">
//               <div
//                 className="service-item wow fadeInUp h-100 shadow rounded p-4 text-center transition-all hover:shadow-lg hover:scale-105"
//                 data-wow-delay={service.delay}
//                 style={{
//                   background: "#fff",
//                   borderRadius: "12px",
//                   transition: "all 0.3s ease-in-out",
//                 }}
//               >
//                 <div className="icon-box mb-3">
//                   <img src={service.icon} alt={service.title} height="60" />
//                 </div>
//                 <div className="service-content">
//                   <h3 className="mb-3 text-dark">{service.title}</h3>
//                   <p style={{ fontSize: "15px", lineHeight: "1.6", color: "#444" }}>
//                     {service.desc}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Growth Journey Section */}
//         <div className="row mt-5">
//           <div className="col-lg-12">
           
//           </div>
//         </div>
//       </div>
//     </div>

// </>
//   );
// };

// export default PageServices;









import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const services = [
  {
    id: 1,
    title: "Quick Rentals",
    desc:
      "Ideal for short trips and urgent requirements. Whether it’s airport transfers, corporate meetings, or daily staff commutes, our quick rental solutions ensure timely, comfortable, and hassle-free travel.",
    icon: "images/icon-service-1.svg",
    delay: "0s",
  },
  {
    id: 2,
    title: "Periodic Rentals",
    desc:
      "Flexible rental options tailored to your needs. Choose from weekly, monthly, or long-term plans that provide cost-effective and reliable travel solutions for both personal and business purposes.",
    icon: "images/icon-service-2.svg",
    delay: "0.2s",
  },
  {
    id: 3,
    title: "Corporate Travel Solutions",
    desc:
      "Designed for executives and employees, we provide seamless corporate mobility solutions. From scheduled office commutes to VIP transfers, we guarantee professionalism, punctuality, and comfort.",
    icon: "images/icon-service-3.svg",
    delay: "0.4s",
  },
  {
    id: 4,
    title: "Events & Exhibitions",
    desc:
      "From weddings and family functions to seminars, conferences, and exhibitions—we offer reliable and well-coordinated transportation services that make every event smooth and stress-free.",
    icon: "images/icon-service-4.svg",
    delay: "0.6s",
  },
  {
    id: 5,
    title: "Customized Travel Packages",
    desc:
      "Explore personalized travel experiences crafted for your needs. Be it family getaways, weekend trips, pilgrimages, or leisure tours, we design packages to give you a memorable journey.",
    icon: "images/icon-service-5.svg",
    delay: "0.8s",
  },
  {
    id: 6,
    title: "Luxury & VIP Transfers",
    desc:
      "Travel in unmatched style and comfort with our premium chauffeur-driven luxury cars. Perfect for dignitaries, celebrities, and high-profile events where class, privacy, and exclusivity matter.",
    icon: "images/icon-service-6.svg",
    delay: "1s",
  },

  // 🔹 ICON-BASED SERVICES
  {
    id: 7,
    title: "Airport Transfers",
    desc:
      "Reliable airport pickup and drop services with real-time flight tracking. Our punctual chauffeurs ensure smooth, stress-free transfers to and from the airport at any hour.",
    icon: "fa-solid fa-plane-departure",
    delay: "1.2s",
  },
  {
    id: 8,
    title: "Corporate Employee Transport",
    desc:
      "Safe and efficient daily commute solutions for corporate staff. We manage employee transportation with fixed schedules, professional drivers, and well-maintained vehicles.",
    icon: "fa-solid fa-building",
    delay: "1.4s",
  },
  {
    id: 9,
    title: "Corporate Events & Delegation Travel",
    desc:
      "End-to-end transportation support for corporate events, conferences, and business delegations, ensuring smooth coordination, punctuality, and premium service standards.",
    icon: "fa-solid fa-briefcase",
    delay: "1.6s",
  },
];

const PageServices = () => {
  return (
    <>
      {/* Page Header */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-center">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Services
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="page-services py-5">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-6 mb-4">
                <div
                  className="service-item wow fadeInUp h-100 shadow rounded p-4 text-center"
                  data-wow-delay={service.delay}
                  style={{
                    background: "#fff",
                    borderRadius: "12px",
                    transition: "all 0.3s ease-in-out",
                  }}
                >
                  {/* ICON RENDER LOGIC */}
                  <div className="icon-box mb-3">
                    {service.icon.startsWith("fa") ? (
                      <i
                        className={service.icon}
                        style={{
                          fontSize: "48px",
                          color: "#212529",
                        }}
                      ></i>
                    ) : (
                      <img
                        src={service.icon}
                        alt={service.title}
                        height="60"
                      />
                    )}
                  </div>

                  <div className="service-content">
                    <h3 className="mb-3 text-dark">
                      {service.title}
                    </h3>
                    <p
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.6",
                        color: "#444",
                      }}
                    >
                      {service.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PageServices;
